export default "__VITE_ASSET__ATloX$sS__"